export default __webpack_public_path__ + "static/media/Stay.af08f336.png";